export var ContextAuditReportStatus;
(function (ContextAuditReportStatus) {
    ContextAuditReportStatus["QUEUED"] = "queued";
    ContextAuditReportStatus["RUNNING"] = "running";
    ContextAuditReportStatus["READY"] = "ready";
    ContextAuditReportStatus["FAILED"] = "failed";
})(ContextAuditReportStatus || (ContextAuditReportStatus = {}));
//# sourceMappingURL=context-audit-report-status.enum.js.map